export const MessageTypeCustom = "Custom";
